import { Injectable } from '@angular/core';
import { BackendService } from '@tg4/http-infrastructure/dist/src';
import { Observable } from 'rxjs';
import { PrincipleItemModelDto } from '../performance-cycles/configuration/cycle-partner-configuration/PrincipleItemModelDto';

@Injectable()
export class DashboardService {


    constructor(private _httpService: BackendService) { }

    public getUserCycles(): Observable<any> {
        return this._httpService.get('getUserCycles');
    }

    public getDashboardProcesses(cycleId: number): Observable<any> {
        return this._httpService.get('getUserAssessmentProcesses', [], [
            { 'name': 'cycleId', 'value': cycleId as any }
        ]);
    }

    public getPartnerPrinciples(cycleId: number) {
        return this._httpService.get<{ fundamentalPrinciples: PrincipleItemModelDto[], leadershipPrinciples: PrincipleItemModelDto[] }>('cyclePrinciples', [], [
            { 'name': 'cycleId', 'value': cycleId as any }
        ]);
    }

    public getUserGoals(cycle: number): Observable<any> {
        return this._httpService.get('getUserGoals', [], [
            { 'name': 'cycle', 'value': cycle as any }
        ]);
    }

    public getGoalById(goalId: number): Observable<any> {
        return this._httpService.get('getGoalById', [], [
            { 'name': 'goalId', 'value': goalId as any }
        ]);
    }

    public getPrinciples(language: string): Observable<any> {
        return this._httpService.get('getDashboardPrinciples', [], [
            { 'name': 'language', 'value': language as any }
        ]);
    }

    public addGoalProgress(goalId: number, progress: number): Observable<any> {
        return this._httpService.post('addGoalProgress', {
            'goalId': goalId,
            'progress': progress
        });
    }

    public addGoalComment(goalId: number, text: string): Observable<any> {
        return this._httpService.post('addGoalComment', {
            'goalId': goalId,
            'text': text
        });
    }

    public deleteGoalComment(goalId: number, commentId: number): Observable<any> {
        return this._httpService.delete('deleteGoalComment', [
            { 'name': 'goalId', 'value': goalId as any },
            { 'name': 'commentId', 'value': commentId as any },
        ]);
    }

    public getMidYearEvaluationSummary(cycleId: number): Observable<any> {
        return this._httpService.get('getMidYearEvaluationSummary', [], [
            { 'name': 'cycleId', 'value': cycleId as any }
        ]);
    }
}
